module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }